/* eslint-disable no-underscore-dangle */
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon, message } from '@/components';
import RTCModel from '@/models/rtc';
import MeetingModel from '@/models/meeting';
import Style from './index.less';

interface SettingPanelProps {
  RTCInstance?: RTCModel;
  meeting?: MeetingModel;
  visible: boolean;
}

const MICSettingPanel: React.FC<SettingPanelProps> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    meeting: store.meeting,
  };
})(
  observer(props => {
    const { RTCInstance, visible } = props;
    const { formatMessage } = useIntl();

    React.useEffect(() => {
      if (visible) {
        RTCInstance?.getDeviceOptions(false);
      }
    }, [visible]);
    return (
      <div
        className={classnames(Style['setting-panel'], { [Style.visible]: visible })}
        onClick={e => {
          e.nativeEvent.stopImmediatePropagation();
        }}
      >
        <div className={Style.device}>
          <h3 className={Style.name}>{formatMessage({ id: 'SPEAKER' })}</h3>
          <div className={Style.option}>
            {RTCInstance && RTCInstance?.deviceOptions.audioOut.length === 0 && (
              <div className={Style['no-data']}>{formatMessage({ id: 'NO_DATA' })}</div>
            )}
            {RTCInstance?.deviceOptions.audioOut.map(item => (
              <div
                className={Style.label}
                onClick={() => {
                  RTCInstance?.setAudioOutValue.bind(RTCInstance)(item.value);
                }}
                key={item.value}
              >
                <span>
                  <Icon
                    name="icon-chosen_nor"
                    size={16}
                    style={{ display: RTCInstance?.audioOutValue === item.value ? '' : 'none' }}
                  />
                </span>
                <span title={item.label}>{item.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={Style.device}>
          <h3 className={Style.name}>{formatMessage({ id: 'MICROPHONE' })}</h3>
          <div className={Style.option}>
            {RTCInstance && RTCInstance?.deviceOptions.audioIn.length === 0 && (
              <div className={Style['no-data']}>{formatMessage({ id: 'NO_DATA' })}</div>
            )}
            {RTCInstance?.deviceOptions.audioIn.map(item => (
              <div
                className={Style.label}
                onClick={() => {
                  if (RTCInstance.isOpenAudio) {
                    RTCInstance?.setAudioInValue.bind(RTCInstance)(item.value);
                  } else {
                    // RTCInstance?.openMic.bind(RTCInstance)(false, item.value);
                    message.warning({
                      content: formatMessage({ id: 'SWITCH_MIC_TIPS' }),
                    });
                  }
                }}
                key={item.value}
              >
                <span>
                  <Icon
                    name="icon-chosen_nor"
                    size={16}
                    style={{ display: RTCInstance?.audioInValue === item.value ? '' : 'none' }}
                  />
                </span>
                <span title={item.label}>{item.label}</span>
              </div>
            ))}
          </div>
        </div>
        <span className={Style.triangle} />
      </div>
    );
  }),
);
export default MICSettingPanel;
